export default __webpack_public_path__ + "static/media/tbank.06756daa.svg";